<!--
  登录弹窗组件 - el-dialog 封装，居中弹出并带从右上角飞入动画
-->
<template>
  <el-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    title="登录您的账户"
    width="520px"
    :close-on-click-modal="false"
    align-center
    class="login-dialog"
    append-to-body
    @open="panelRef?.resetWechat()"
    @close="panelRef?.cleanupWechat()"
  >
    <LoginPanel
      ref="panelRef"
      @login-success="(data) => { emit('login-success', data); emit('update:modelValue', false) }"
      @register-success="(data) => { emit('register-success', data); emit('update:modelValue', false) }"
      @close="emit('update:modelValue', false)"
    />
  </el-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import LoginPanel from './LoginPanel.vue'

interface Props {
  modelValue: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'login-success', data: any): void
  (e: 'register-success', data: any): void
}>()

const panelRef = ref<InstanceType<typeof LoginPanel>>()
</script>

<style>
.login-dialog.el-dialog {
  width: min(500px, calc(100vw - 32px)) !important;
  height: min(600px, calc(100vh - 24px));
  max-height: calc(100vh - 24px);
  display: flex;
  flex-direction: column;
  border-radius: 28px;
  overflow: hidden !important;
  background:
    radial-gradient(circle at 8% 0%, rgba(125, 211, 252, 0.42), transparent 35%),
    radial-gradient(circle at 94% 8%, rgba(72, 134, 255, 0.2), transparent 30%),
    linear-gradient(180deg, rgba(239, 249, 255, 0.8) 0%, rgba(255, 255, 255, 0.96) 48%),
    #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.76);
  box-shadow: 0 30px 90px rgba(15, 23, 42, 0.24), 0 0 0 1px rgba(72, 134, 255, 0.08);
}

.login-dialog .el-dialog__header {
  position: relative;
  flex: 0 0 auto;
  padding: 24px 34px 12px;
  border-bottom: 0;
}

.login-dialog .el-dialog__header::after {
  content: "";
  position: absolute;
  left: 32px;
  right: 32px;
  bottom: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(72, 134, 255, 0.18), transparent);
}

.login-dialog .el-dialog__title {
  color: #182033;
  font-size: 24px;
  font-weight: 800;
}

.login-dialog .el-dialog__headerbtn {
  top: 18px;
  right: 24px;
  width: 36px;
  height: 36px;
  border-radius: 999px;
  transition: var(--tts-transition-fast);
}

.login-dialog .el-dialog__headerbtn:hover {
  background: rgba(72, 134, 255, 0.08);
}

.login-dialog .el-dialog__body {
  flex: 1 1 auto;
  padding: 14px 32px 24px;
  overflow: hidden !important;
  max-height: none;
}

@media (max-width: 560px) {
  .login-dialog .el-dialog__header {
    padding: 24px 22px 16px;
  }

  .login-dialog .el-dialog__header::after {
    left: 22px;
    right: 22px;
  }

  .login-dialog .el-dialog__body {
    padding: 16px 20px 24px;
    max-height: none;
  }
}

/* 覆盖 dialog-fade 入场动画，让登录弹窗从右上角飞入居中 */
.dialog-fade-enter-active .login-dialog,
.dialog-fade-enter-active.el-overlay-dialog .login-dialog {
  animation: login-zoom-in 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) both !important;
}

.dialog-fade-leave-active .login-dialog,
.dialog-fade-leave-active.el-overlay-dialog .login-dialog {
  animation: login-zoom-out 0.2s ease-in both !important;
}

@keyframes login-zoom-in {
  from {
    opacity: 0;
    transform: scale(0.6) translate(25%, -25%);
  }
  to {
    opacity: 1;
    transform: scale(1) translate(0, 0);
  }
}

@keyframes login-zoom-out {
  from {
    opacity: 1;
    transform: scale(1) translate(0, 0);
  }
  to {
    opacity: 0;
    transform: scale(0.6) translate(25%, -25%);
  }
}
</style>
